<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        setTimeout(async function() {
        $('#spinner').modal('toggle');
      
        let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
        if (response && response.status==200){
            payload.user = response.result;
            payload.data.email = payload.user.email;
        } 
        $('#spinner').modal('toggle');
        }, 100);
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            let user = JSON.parse(JSON.stringify(this.data));
            user.password = this.newPassword;

            let userLoginTest = JSON.parse(JSON.stringify(this.data));
            userLoginTest.email = this.$session.get('user').email;
            console.log(userLoginTest);


            Request.do(this, 'POST', Request.getDefaultHeader(this), userLoginTest, `${Endpoints.systemUsers.login}`,
                async (dataResponse, fullResponse)=>{//SUCCESS CALLBACK
                    
                    Request.do(state, 'POST', Request.getDefaultHeader(state), user, `${Endpoints.systemUsers.resetPass}`,
                        (userResponse)=>{//SUCCESS CALLBACK
                            $('#spinner').modal('toggle');
                            this.flashMessage.success(
                        this.configMessage(this.$t('string.msg.changePassword.register.title.success'), this.$t('string.msg.changePassword.register.message.success'),'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.changePassword.register.message.success')),
                            destroyed: this.clearText()
                        })
                        },
                        (error)=>{//ERROR CALLBACK
                            $('#spinner').modal('toggle');
                            let res = error.response;
                            if (res && res.status){
                                state.titleToast = state.$t("string.msg.warning");
                                if (res.data.messageId === 'response.msg.error.incorrect.fields'){
                                    let fields = "";
                                    res.data.errors.forEach(function (value) {
                                        fields += state.$t(value.id)+";<br/>";
                                    });
                                    state.titleToast = state.$t(res.data.messageId);
                                    state.messageToast = state.$t(fields);
                                }else if (res.data.messageId === 'response.already.exists'){
                                    state.messageToast = state.$t('response.company.already.exists');
                                }else{
                                    state.messageToast = state.$t(res.data.messageId);
                                    state.messageIdToast = res.data.messageId;
                                }
                                $('#toast').modal('show');
                            }
                            console.log(JSON.stringify(error));
                    });
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');

                    let res = error.response;
                    if (res && res.status != 200){
                        state.titleToast = state.$t("string.msg.warning");
                        if (res.data.messageId === 'response.user.password.incorrect'){
                            state.messageToast = state.$t("response.user.password.actual.incorrect");
                        }else{
                            state.messageToast = state.$t(res.data.messageId);
                            state.messageIdToast = res.data.messageId;
                        }
                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
            
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.data.email) {
                this.errors.push(this.$t('string.msg.user.change.current.password.required'));
            }
            if (!this.newPassword) {
                this.errors.push(this.$t('string.msg.user.change.password.required'));
            }
            if (!this.cfNewPassword) {
                this.errors.push(this.$t('string.msg.user.change.cnpassword.required'));
            }
            if(this.newPassword != this.cfNewPassword) {
                this.errors.push(this.$t('string.msg.user.change.password.label.equals'));
            }
            // if(!this.checkPassword()){
            //     this.errors.push(this.$t('string.msg.user.change.password.label.invalid'));
            // }
            if(this.errors.length>0){
                e.preventDefault();
            }else{
                console.log("##### DATA:");
                console.log(this.data);
                this.save();
            }
        },
        checkPassword: function (e){
             
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },

    }
}
</script>
